// TODO: refactor code to get rid of standard html elements

import {
  WSButton,
  WSButtons,
  WSRadioInput,
  WSText
} from "@wingspanhq/fe-component-library";
import {
  ExternalBankAccount,
  PayoutSettings
} from "@wingspanhq/wingspan-api-sdk";
import React, { useEffect, useMemo, useState } from "react";
import { WSErrorMessage } from "../../../components/WSErrorMessage/WSErrorMessage";
import { ErrorContextKey } from "../../../services/platform";
import { selectorExternalBankAccountFullName } from "@selectors/selectorExternalBankAccountFullName";
import { selectorExternalBankAccountInstitution } from "@selectors/selectorExternalBankAccountInstitution";
import { selectorExternalBankAccountPayoutReady } from "@selectors/selectorExternalBankAccountPayoutReady";
import { IconInstitution } from "../IconInstitution";
import styles from "./index.module.scss";

type Props = {
  externalBankAccounts: ExternalBankAccount[];
  payoutSettings?: PayoutSettings;
  onSubmit: (accountId: string) => void;
  onLinkAnotherAccount: () => void;
  error?: any;
  isLoading?: boolean;
};

export const Form: React.FC<Props> = ({
  externalBankAccounts,
  payoutSettings,
  onSubmit,
  onLinkAnotherAccount,
  error,
  isLoading
}) => {
  const [value, setValue] = useState("");

  const filteredAccounts = useMemo(
    () => externalBankAccounts.filter(selectorExternalBankAccountPayoutReady),
    [externalBankAccounts]
  );

  useEffect(() => {
    const standardDestination = payoutSettings?.standardDestination;
    const currentPayoutAccount = filteredAccounts.find(
      externalBankAccount => externalBankAccount.id === standardDestination?.id
    );

    setValue(
      currentPayoutAccount
        ? currentPayoutAccount.id
        : filteredAccounts.length > 0
          ? filteredAccounts[0].id
          : ""
    );
  }, [filteredAccounts, payoutSettings]);

  const accountsByInstitution: { [key: string]: ExternalBankAccount[] } = {};

  filteredAccounts.forEach(externalBankAccount => {
    const institution =
      selectorExternalBankAccountInstitution(externalBankAccount) || "";
    if (!accountsByInstitution[institution])
      accountsByInstitution[institution] = [];

    accountsByInstitution[institution].push(externalBankAccount);
  });

  return Object.keys(accountsByInstitution).length > 0 ? (
    <>
      {Object.keys(accountsByInstitution).map(institution => (
        <div key={institution} className={styles.section}>
          <h3 className={styles.sectionTitle}>{institution}</h3>
          <ul>
            {accountsByInstitution[institution].map(externalBankAccount => (
              // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
              <li
                key={externalBankAccount.id}
                onClick={() => {
                  setValue(externalBankAccount.id);
                }}
                data-testid={`account-item-${externalBankAccount.id}`}
              >
                <div className={styles.name}>
                  <IconInstitution />
                  {selectorExternalBankAccountFullName(externalBankAccount)}
                </div>
                <WSRadioInput
                  name="user-account"
                  value={externalBankAccount.id}
                  checked={value === externalBankAccount.id}
                />
              </li>
            ))}
          </ul>
        </div>
      ))}

      <WSErrorMessage
        my="XL"
        contextKey={ErrorContextKey.CreateAccount}
        error={error}
      />

      <WSButtons forceFullWidth format="modal">
        <WSButton
          name="proceedSelectedAccount"
          onClick={() => {
            onSubmit(value);
          }}
          loading={isLoading}
        >
          Proceed with selected account
        </WSButton>
        <WSButton
          data-testid="linkAccount"
          kind="Secondary"
          onClick={onLinkAnotherAccount}
        >
          Link another account
        </WSButton>
      </WSButtons>
    </>
  ) : (
    <>
      <WSText mb="XL">
        We weren't able to find any accounts eligible for deposits. Please try
        connecting another bank account.{" "}
      </WSText>
      <WSButton
        data-testid="linkAccount"
        fullWidth
        onClick={onLinkAnotherAccount}
      >
        Link a different account
      </WSButton>
    </>
  );
};
